/* Zocker Theme JS */

// Slider scroll helper — scrolls one child width per click
function scrollSlider(id, direction) {
  var el = document.getElementById(id);
  if (!el) return;
  var child = el.querySelector(':scope > *');
  var w = child ? child.offsetWidth + 16 : 300;
  el.scrollBy({ left: direction * w, behavior: 'smooth' });
}

// Variant option selection
function selectVariantOption(btn, optionName, optionValue) {
  // Remove active from siblings
  btn.parentElement.querySelectorAll('.variant-option').forEach(function(b) {
    b.classList.remove('bg-black', 'text-white', 'border-black');
    b.classList.add('border-neutral-300');
  });
  btn.classList.add('bg-black', 'text-white', 'border-black');
  btn.classList.remove('border-neutral-300');
}

// Image modal (placeholder — enhance as needed)
function openImageModal(index) {
  // Can be enhanced with a proper lightbox library
  console.log('Open image modal at index:', index);
}
